import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Spinner } from './ui';
export default function ProtectedRoute({ permission, children }) {
  const { user, loading, can } = useAuth();
  const loc = useLocation();
  if (loading) return <Spinner label="Checking session…" />;
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  if (permission && !can(permission)) return <div className="panel"><h2>Access denied</h2>
    <p className="muted">Your role does not include <code>{permission}</code>.</p></div>;
  return children;
}
